// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__3Mphc","paymentContainer":"PaymentPage_paymentContainer__pLg9y"};